import { render, staticRenderFns } from "./UpsertTracingProductModal.vue?vue&type=template&id=380e55da&scoped=true&"
import script from "./UpsertTracingProductModal.vue?vue&type=script&lang=ts&"
export * from "./UpsertTracingProductModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpsertTracingProductModal.vue?vue&type=style&index=0&id=380e55da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380e55da",
  null
  
)

export default component.exports